// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2P-1g","ranges":"BmiRanges_ranges__2P9m4"};